import { styled } from '@mui/material';

interface StyledChatToggleProps {
  isChatWindowOpen: boolean;
  themeColor?: string;
}

const StyledChatToggle = styled('div')<StyledChatToggleProps>`
  height: ${({ isChatWindowOpen }) => (isChatWindowOpen ? '40px' : '80px')};
  width: ${({ isChatWindowOpen }) => (isChatWindowOpen ? '40px' : '80px')};
  background-color: ${props =>
    (props.themeColor as string) || 'rgb(23, 65, 255)'};
  border-radius: 50%;
  position: absolute;
  bottom: 1rem;
  right: 0;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;

  & img.chat-close-icon {
    height: 1rem;
    width: 1rem;
  }
`;

export default StyledChatToggle;
